//CASL
import { abilitiesPlugin } from "@casl/vue";
import store from "./store";
import NewApiService from "@/utils/new.api.service";
import VueLodash from "lodash";
import Vue from "vue";
import VueRouter from "vue-router";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
// Plugins
import VueCurrencyFilter from 'vue-currency-filter'
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
// router setup
import routes from "./routes/routes";

import FlashMessage from "@smartweb/vue-flash-message";


const options = { name: "lodash" };
Vue.use(VueLodash, options); // options is optional

// plugin setup
Vue.use(VueRouter);


Vue.use(VueCurrencyFilter,
  {
      symbol : 'CHF',
      thousandsSeparator: '\'',
      fractionCount: 2,
      fractionSeparator: '.',
      symbolPosition: 'front',
      symbolSpacing: true,
      avoidEmptyDecimals: undefined,
  }
)


//Vue.use(DashboardPlugin);

NewApiService.init();

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            selector: to.hash,
            offset: { x: 0, y: 70 },
            behavior: 'smooth',
          })
        }, 500)
      })
    }
  },
});

// Ensure we checked auth before each page load.
router.beforeEach((to, _from, next) => {
  Promise.all([store.dispatch("auth/check_auth")]);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters["auth/isAuthenticated"]) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
});


Vue.use(abilitiesPlugin, store.getters["auth/ability"]);

Vue.use(FlashMessage, {
  time:4000,
  strategy:'multiple'
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  vuetify,
});
